export class StockInRqstDto {
    month: number;
    year: number;
    unitId: string;
    reportType: string;
}